var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Units from "../units";
var unitsLowerCase = Object.keys(Units).reduce(function (soFar, current) {
    var _a;
    return __assign(__assign({}, soFar), (_a = {}, _a[current.toLowerCase()] = Units[current], _a));
}, {});
export var unitLookup = function (unitString) {
    return (unitString &&
        unitsLowerCase[unitString.toLowerCase()]) ||
        undefined;
};
//# sourceMappingURL=index.js.map